import { createTheme as m } from "../../_mixins/use-theme.js";
import i from "./_common.js";
import p from "../../_styles/common/light.js";
import s from "../../popover/styles/light.js";
import { composite as a } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function c(t) {
  const {
    borderRadius: r,
    boxShadow2: e,
    baseColor: o
  } = t;
  return Object.assign(Object.assign({}, i), {
    borderRadius: r,
    boxShadow: e,
    color: a(o, "rgba(0, 0, 0, .85)"),
    textColor: o
  });
}
const n = m({
  name: "Tooltip",
  common: p,
  peers: {
    Popover: s
  },
  self: c
}), d = n;
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tooltip/styles/light.js
// module id = 477
// module chunks = 41